export default __webpack_public_path__ + "static/media/CCA_RGB_black_e.e2e45ad6.svg";